import { createUserManager } from "redux-oidc";

const userManageConfig = {
    authority: "http://localhost:5105",
    client_id: "util", // Client app-identifier registered with OIDC/OAUTH
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
    response_type: "id_token token",
    scope: "openid profile webutilsagg",
    filterProtocolClaims: true,
    automaticSilentRenew: true,
    loadUserInfo: true
};

const userManager = createUserManager(userManageConfig);

export default userManager;